import styled from 'styled-components';
import { positionEnum } from "../../enums/positionEnum";
import { getMultipliedIndent } from "../../theme/selectors";

var getAddonMargin = function getAddonMargin(_ref) {
  var position = _ref.position,
      marginSize = _ref.marginSize,
      theme = _ref.theme;
  var indent = getMultipliedIndent(theme, marginSize !== null && marginSize !== void 0 ? marginSize : 0);

  if (position === positionEnum.right) {
    return "\n      margin-left: ".concat(indent, ";\n    ");
  }

  return "\n      margin-right: ".concat(indent, ";\n    ");
};

var ComponentAddon = styled.div.attrs(function (props) {
  return {
    position: props.position || positionEnum.left,
    marginSize: props.marginSize || 1
  };
}).withConfig({
  displayName: "ComponentAddon",
  componentId: "sc-7b19i-0"
})(["display:flex;align-items:center;justify-content:center;", ""], getAddonMargin);
export default ComponentAddon;